const contentFollow = () => import('@/pages/content/follow/index.vue');

export default [{
    path: '/content/follow',
    component: contentFollow,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '关注我们',
        activeRoute: '/content/follow'
    }]
}];